/** Usuario restringido a su propia cartera (p. ej. pruebas de agente). */
export function usuarioSoloCarteraPropia(usuario) {
  return Boolean(usuario?.solo_cartera_propia && usuario?.agente_id);
}

export function filtrarPorCarteraUsuario(items, usuario, getAgenteId = (row) => row?.agente_id) {
  if (!usuarioSoloCarteraPropia(usuario)) return items;
  const aid = String(usuario.agente_id);
  return (items || []).filter((row) => String(getAgenteId(row) || "") === aid);
}
